import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { GENERAL_CASHBACK_202505_GA_TAGS } from 'src/constants';
import Upsell1Img from 'src/images/perspective_202505/section/what_paidy/upsell-1.png';
import Upsell2Img from 'src/images/perspective_202505/section/what_paidy/upsell-2.png';
import Upsell3Img from 'src/images/perspective_202505/section/what_paidy/upsell-3.png';
import Upsell4Img from 'src/images/perspective_202505/section/what_paidy/upsell-4.png';
import styles from './WhatPaidy.module.scss';

const ITEMS = [
  {
    key: 1,
    alt: 'upsell-1',
    src: Upsell1Img,
    url: '/guide#shopping',
    gaTag: GENERAL_CASHBACK_202505_GA_TAGS.INTRO_1,
  },
  {
    key: 2,
    alt: 'upsell-2',
    src: Upsell2Img,
    url: '/guide/#payment',
    gaTag: GENERAL_CASHBACK_202505_GA_TAGS.INTRO_2,
  },
  {
    key: 3,
    alt: 'upsell-3',
    src: Upsell3Img,
    url: '/guide/#payment',
    gaTag: GENERAL_CASHBACK_202505_GA_TAGS.INTRO_3,
  },
  {
    key: 4,
    alt: 'upsell-4',
    src: Upsell4Img,
    url: '/npay',
    description: '*口座振替・銀行振込のみ無料',
    gaTag: GENERAL_CASHBACK_202505_GA_TAGS.INTRO_4,
  },
];

export default function WhatPaidy() {
  return (
    <div className={styles.whatPaidy}>
      <div className={styles.row}>
        {ITEMS.map((item) => (
          <div key={item.key}>
            <OutboundLink
              rel="noopener noreferrer"
              target="_blank"
              href={item.url}
              className={item.gaTag}
            >
              <img alt={item.alt} src={item.src} width={164} height={197} />
            </OutboundLink>
            {item.description && (
              <p className={styles.text}>{item.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
